export function Arrow45Icon() {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_9847_86568)'>
        <path
          d='M12.2422 3.75781L3.75691 12.2431'
          stroke='#292A43'
          strokeWidth='1.3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12.2422 10.8289V3.75781'
          stroke='#292A43'
          strokeWidth='1.3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M5.1715 3.7577H12.2426'
          stroke='#292A43'
          strokeWidth='1.3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_9847_86568'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
